<div class="content-wrapper">
    <h3>Reset Password</h3>
    <div class="question-block">
        @if(!forcedUpdate) {
        <p>If you wish to change your account password, please enter
            your new password below.</p>
        } @else {
        @if(updateSource == 0) {
        <p>You must update your password before continuing. Please choose something secure, and which does not
            match any other password you have used.</p>
        } @else {
        <p>We have recently updated our password encryption routines and need you to enter a new password.</p>
        <p>You must update your password before continuing. Please choose something secure, and which does not
            match any other password you have used.</p>
        }
        }
        @if(form){
        <lib-metaform-display [form]="form" [showButtons]="false"
            (formEvent)="onFormEvent($event)"></lib-metaform-display>
        }
        <div class="actions">
            <app-cf-button [type]="ButtonType.SignIn" [style]="ButtonStyle.Wide" [enabled]="updatePasswordButtonEnabled"
                (click)="doResetPassword()" [showProcessing]="isProcessing">Reset password</app-cf-button>
        </div>
    </div>